<section *ngIf="(isLoading$ | async)" class="overlay">
  <mat-progress-spinner
    class="overlay__spinner"
    diameter="57"
    color="accent"
    mode="indeterminate"
    strokeWidth="2"
  ></mat-progress-spinner>
</section>
